import { AwsClient } from "aws4fetch";
import { map } from 'lodash';
import store from '../store';
import { setLoading, setSnackbar } from '../actions/alertActions';
import { refreshToken } from '../actions/loginActions';

const UNAUTHORIZED = 401;

export async function fetchApi(url, params, successCallback, errorCallback) {
  try {
    store.dispatch(setLoading(1, 'Loading...'));
    const state = store.getState();
    if (!(state && state.tokenReducer && state.tokenReducer)) {
      throw new Error('Store not initialized yet');
    }
    const { access_token } = state.tokenReducer;
    if (
      !(
        access_token ||
        url.path.includes('auth') ||
        url.path.includes('registration') ||
        url.path.includes('general') ||
        url.path.includes('payment') ||
        url.path.includes('survey')
      )
    ) {
      store.dispatch(setSnackbar('error', 'You need to login!'));
      throw new Error('Need access token for the operation');
    }
    const prepareFetchRequest = signFetchRequest(url.path, state.loginReducer.aws_credentials)
    let signedRequest;
    if (url.method === 'GET') {
      const endUrl = `${url.path}?${buildFetchApiParameters(params)}`;
      signedRequest = await prepareFetchRequest(endUrl, {
        method: url.method,
        headers: {
          Accept: 'application/json',
          't-access-token': access_token
        },
        credentials: 'include'
      });
    } else {
      signedRequest = await prepareFetchRequest(url.path, {
        method: url.method,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          't-access-token': access_token
        },
        credentials: 'include',
        body: JSON.stringify({ ...params })
      });
    }
    const response = await fetch(signedRequest);
    if (response.ok) {
      const data = await response.json();
      successCallback(data);
      store.dispatch(setLoading(0, ''));
    } else {
      store.dispatch(setLoading(0, ''));
      const error = await response.json();
      console.log(error, 'errorData');
      if (url.path.includes('payment')) {
        store.dispatch(setSnackbar('error', error.message));
      }
      if (error.is_visible) {
        store.dispatch(setSnackbar('error', error.go_error_message));
      }
      errorCallback(error);
      if (
        error.http_status_code === UNAUTHORIZED &&
        error.go_error_code === 2 &&
        !url.path.includes('refresh_token')
      ) {
        store.dispatch(
          refreshToken(
            () => fetchApi(url, params, successCallback, errorCallback),
            () => { }
          )
        );
      } else {
        errorCallback(error);
      }
    }
  } catch (error) {
    store.dispatch(setSnackbar('error', 'An unknown error occurred!'));
    errorCallback(error);
  }
}

const isUnSignedApiPath = (path) =>
  [
    "/go_shield/auth/login",
    "/go_shield/auth/refresh_token",
    "/go_shield/auth/reset_password",
    "/go_shield/registration",
    "/go_shared/"
  ].some(p => path.includes(p))

const signFetchRequest = (path, awsCredentials) => {
  const isPathUnsigned = isUnSignedApiPath(path)
  const env = process.env.VITE_CUSTOM_ENV || 'local';
  if (env === 'local' || isPathUnsigned) {
    return (...params) => new Promise((resolve) => resolve(new Request(...params)))
  }
  const aws = new AwsClient({
    accessKeyId: awsCredentials.AccessKeyId,
    secretAccessKey: awsCredentials.SecretKey,
    region: process.env.VITE_API_REGION || 'us-east-1',
    service: 'execute-api',
    sessionToken: awsCredentials.SessionToken
  })
  return (...params) => aws.sign(...params);
};

const buildFetchApiParameters = (data) => {
  const params = new URLSearchParams();
  map(data, (value, key) => {
    if (Array.isArray(data[key])) {
      map(value, (item) => params.append(`${key}[]`, item));
    } else {
      params.append(key, value);
    }
  });
  return params;
};
